// client/src/components/public/BrokerageIdentity.js — the brokerage identity block every
// listing carries (Illinois 68 IAC 1450.715(b)/1450.720; Florida Rule 61J2-10.025), the
// MLS attribution for another brokerage's listing, and the MLS disclaimer + timestamp.
// The words come from the server (lib/listingSources/display, per state); nothing here
// is hard-coded to one state.
import React from 'react';
import { Link } from 'react-router-dom';

export const IdentityLine = ({ identity, className = '' }) => {
    if (!identity) return null;
    return (
        <p className={`text-xs text-slate-600 ${className}`}>
            <Link to="/office-registry" className="underline hover:text-indigo-700">{identity.brokerage_name}</Link>, {identity.broker_label}
            {identity.location ? ` · ${identity.location}` : ''}
        </p>
    );
};

export const Attribution = ({ listing, className = '' }) => {
    if (!listing || listing.source !== 'idx' || !listing.attribution) return null;
    return (
        <p className={`text-xs text-slate-600 ${className}`}>
            {listing.attribution.text}{listing.attribution.mls_name ? ` · Source: ${listing.attribution.mls_name}` : ''}
            {listing.mls_number ? ` · MLS# ${listing.mls_number}` : ''}
        </p>
    );
};

export const IdentityBlock = ({ identity }) => {
    if (!identity) return null;
    return (
        <section aria-label="Brokerage identification" className="rounded-lg border border-slate-200 bg-white p-4 text-sm text-slate-700">
            <p className="font-semibold text-slate-900">{identity.brokerage_name}</p>
            <p>{identity.broker_label}{identity.licence_number ? ` · ${identity.licence_label}${identity.licence_number}` : ''}</p>
            {identity.location && <p>{identity.location}</p>}
            {identity.phone && <p>Phone: <a className="underline" href={`tel:${identity.phone}`}>{identity.phone}</a></p>}
            {identity.email && <p>Email: <a className="underline" href={`mailto:${identity.email}`}>{identity.email}</a></p>}
            {identity.url && <p><a className="underline" href={identity.url}>{identity.url.replace(/^https?:\/\//, '')}</a></p>}
        </section>
    );
};

export const Disclaimer = ({ text }) => (text
    ? <p className="mt-6 text-xs leading-relaxed text-slate-600" role="note">{text}</p>
    : null);
